/**
 * ProtectedLayout - Combines authentication protection with the main layout.
 * This component wraps protected routes with both authentication checks and
 * the main application layout (sidebar, header, etc.).
 */

import { Outlet } from "react-router-dom";
import { MainLayout } from "./MainLayout";

/**
 * Layout component for protected routes.
 * Renders the MainLayout with an Outlet for nested routes.
 * Authentication is handled by the parent ProtectedRoute wrapper.
 */
export function ProtectedLayout() {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}
